<div class="language-switch" [class.compact]="compact" aria-label="Language switch">
  <button
    type="button"
    [class.active]="currentLanguage === 'bn'"
    (click)="setLanguage('bn')"
  >
    বাং
  </button>

  <button
    type="button"
    [class.active]="currentLanguage === 'en'"
    (click)="setLanguage('en')"
  >
    Eng
  </button>
</div>
